export const validateForm = (props, state) => {
    const fields = props.data.Fields.filter((fields) => (fields.ItemType !== 'HiddenField' && fields.ItemType !== 'UTMHiddenField'));

    let errorRecords = [];

    fields.forEach(field => {
        const answer = state.currentAnswer.find(answer => answer.FieldId === field.Id).Value;

        if(field.IsMandatory && answer.length === 0)
            errorRecords.push(true);
        else if (!!field.ValidationRegEx && answer.length > 0) {
            const myRegEx = new RegExp(field.ValidationRegEx, 'i');
            errorRecords.push(!myRegEx.exec(answer));
        }
        else {
            errorRecords.push(false);
        }
    });

    return (!errorRecords.find(error => error === true));
}